import React, { useState } from 'react';
import './MuseoPage.css';

import { PageTitle, Heading } from '../../../components'; 
import { FaArrowRight, FaPlus } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

import { museoData } from '../../../constants';

import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";

import { useTranslation } from 'react-i18next';

const MuseoPage = () => {

    const { t } = useTranslation();

    const { id } = useParams();
    const pageData = id
        ? museoData.find(item => item.id.toString() === id)
        : museoData[0];

    const [index, setIndex] = useState(-1);
    
    const galleryImages = pageData?.gallery || [];

    const currentImage = galleryImages[index];
    const nextIndex = (index + 1) % galleryImages.length;
    const nextImage = galleryImages[nextIndex] || currentImage;
    const prevIndex = (index + galleryImages.length - 1) % galleryImages.length;
    const prevImage = galleryImages[prevIndex] || currentImage;

    const openLightbox = (i) => setIndex(i);
    const closeLightbox = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    if (!pageData) {
        return (
            <div style={{ padding: '100px', textAlign: 'center' }}>
                <h2>{t('museo.notFound')}</h2>
            </div>
        );
    }

    return (
        <>
            <PageTitle 
                title={t(pageData.titleKey)} 
                page={t(pageData.titleKey)} 
            />

            <section className='event-single page-single'>

                <div className='event-info page-info'>

                    <div className='image'>
                        {pageData.image && <img src={pageData.image} alt={t(pageData.titleKey)} />}
                    </div>

                    <div className='content'>

                        <h3 className='main-heading'>
                            {t(pageData.titleKey)}
                        </h3>

                        {pageData.paragraphsKeys.map((key, index) => (
                            <p key={index} style={{ marginBottom: '15px' }}>
                                {t(key)}
                            </p>
                        ))}

                        {pageData.agenda && (
                            <div className='sub-section'>
                                <h3 className='sub-heading'>{t('museo.agenda.heading')}</h3>

                                <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                                    {t(pageData.agenda.introKey)}:
                                </p>

                                <ul className='custom-list'>
                                    {pageData.agenda.pointsKeys.map((key, index) => (
                                        <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                            <FaArrowRight className='icon' style={{ color: 'var(--main-color)', flexShrink: 0 }} />
                                            <span>{t(key)}</span>
                                        </li>
                                    ))}
                                </ul>

                                <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                                    {t(pageData.agenda.endKey)}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                {galleryImages.length > 0 && (
                    <div className="museo-gallery-section">
                        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                            <Heading title={t('museo.galleryTitle')} subTitle={t('museo.gallerySubTitle')} />
                        </div>

                        <div className='museo-gallery-grid'>
                            {galleryImages.map((item, i) => {
                                return (
                                    <div key={i} className={`museo-gallery-item`}>
                                        <img src={item} alt={`${t('museo.exhibit')} ${i + 1}`} />
                                        <div className="museo-gallery-overlay">
                                            <button onClick={() => openLightbox(i)}>
                                                <FaPlus className='museo-gallery-icon' />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {index !== -1 && (
                            <Lightbox
                                mainSrc={currentImage}
                                mainSrcThumbnail={currentImage}
                                nextSrc={nextImage}
                                nextSrcThumbnail={nextImage}
                                prevSrc={prevImage}
                                prevSrcThumbnail={prevImage}
                                onCloseRequest={closeLightbox}
                                onMovePrevRequest={handleMovePrev}
                                onMoveNextRequest={handleMoveNext}
                            />
                        )}
                    </div>
                )}
            </section>
        </>
    );
}

export default MuseoPage;